import React from 'react';
import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var querystring = require('querystring');
import CommentItem from './CommentItem';
import CommentBox from './CommentBox';

var commentArr = [];

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.generateComment = this.generateComment.bind(this);
        this.state = {commentArr: [], start: 0, limit: 5, end: 0, comments: []};
        this.getComments = this.getComments.bind(this);
    }


    generateComment(comments) {

        var newArry = [];
        if (comments.length > 0) {
            for (var c_item of comments) {

                newArry.unshift(
                    <CommentItem user={this.props.user} onChange={this.handleChange.bind(this)} key={"comment-" + c_item.id_comment} comment={c_item} feed={this.props.feed}/>
                )
            }
            //console.log(commentArr);
            this.setState({commentArr: newArry});
        }

        //this.forceUpdate();
        //store.dispatch(getUserSuccess(response.data.data));

    }

    handleChange(comment, type = "update") {
        var commentList = this.state.comments;
        for (var i = 0; i < commentList.length; i++) {
            if (commentList[i].id_comment == comment.id_comment) {
                if(type == "delete")
                {
                    commentList.splice(i,1);
                    this.props.handleComment(comment, type);
                }
                else {
                    commentList[i] = comment;
                }
                //var newFeed =Object.assign(this.props.feed,{comments:commentList});

                this.setState({comments: commentList}, () => {
                    this.generateComment(this.state.comments)
                });
                break;
            }
        }
    }

    handleComment(comment) {
        var comments = this.state.comments;
        comments.unshift(comment);
        this.setState({comments: comments}, () => {
            this.generateComment(this.state.comments)
        });
        this.props.handleComment(comment);
    }

    componentDidMount() {
        //this.generateComment(this.props);
        //console.log("did mount");
        if (this.props.feed.comments_count > 0) {
            this.setState({start: 0, commentArr: []}, () => {
                this.getComments(this.props.feed.id_feed, this.props.feed.feed_type, this.state.start);
            });
            //this.getComments(this.props.feed.id_feed,this.state.start);
        }

    }

    // handleLike(event) {
    //     var api = commonApi.getAPIURL() + '?api=likeFeed&id_feed=' + this.props.feed.id_feed
    //     if (this.props.feed.feed_type == 'job_post') {
    //         api = commonApi.getAPIURL() + '?api=likeJobPostFeed&id_feed=' + this.props.feed.id_feed
    //     }
    //
    //     axios.get(api)
    //         .then(response => {
    //             if (response.data.status == 1) {
    //                 var liked = 0;
    //                 if (this.props.feed.liked == 0) {
    //                     liked = 1;
    //                 }
    //                 var newFeed = Object.assign(this.props.feed, {likes: response.data.data, liked: liked});
    //
    //                 this.props.handleFeedCallback(newFeed);
    //                 //this.setState(Object.assign(this.state,{feeds:response.data.data}));
    //                 //store.dispatch(getUserSuccess(response.data.data));
    //             }
    //             //console.log(response.data);
    //
    //             return response;
    //         });
    // }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.feed.comments_count > 0) {
    //         //this.setState({start:0,commentArr:[]},()=>{this.getComments(nextProps.feed.id_feed,this.state.start);});
    //     }
    // }

    getComments(id_feed, feed_type, start) {
        var url = '/code/api_feeds.php?api=getCommentFeeds&id_feed=' + id_feed + '&feed_type=' + feed_type + '&start=' + start;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    var end = start + response.data.data.length;
                    //var newFeed =Object.assign(this.props.feed,{likes:response.data.data,liked:liked});
                    var comments = this.state.comments;
                    comments = comments.concat(response.data.data);
                    //this.props.handleFeedCallback(newFeed);
                    this.setState({end: end, comments: comments}, () => {
                        this.generateComment(this.state.comments)
                    });
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
    }

    showMore(e) {
        if (this.state.end % this.state.limit == 0) {
            var start = this.state.end;
            this.setState({start: start}, () => {
                this.getComments(this.props.feed.id_feed, this.props.feed.feed_type, this.state.start);
            });
        }
    }


    render() {
        return (<div>
            <div className="comment_feed_section">
                {(this.state.end % this.state.limit == 0 && this.state.end < this.props.feed.comments_count && this.props.feed.comments_count > this.state.limit) ? (
                    <div className="show_more">
                        <a onClick={this.showMore.bind(this)}>show previous comments</a>
                    </div>) : ""}
                {this.state.commentArr}
                {this.props.user != 0 ? (<CommentBox getInput={this.props.getInput} user={this.props.user} onComment={this.handleComment.bind(this)} feed={this.props.feed}/>) : ""}
            </div>
        </div>);
    }
}

export default Comment;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/Comment.js
 **/